const side_nav = {
	administration: {
		budget: "Einnahmen/Ausgaben",
		discounts: "Rabatte",
		invoices: "Rechnungen",
		orders: "Bestellungen",
		quotes: "Angebote",
		title: "Verwaltung",
	},
	customers: {
		debtor_groups: "Debitorgruppen",
		debtors: "Debitor",
		title: "Kunden",
		users: "Benutzer",
	},
	domains: {
		management: "Verwalten",
		register: "Registrieren",
		title: "Domaenen",
	},
	management: {
		api_keys: "API-Keys",
		ip_blacklist: "IP-Blacklist",
		logs: "Logbuch",
		ns_groups: "Individuelle NS-Gruppen",
		staff: "Mitarbeiter",
		title: "Management",
	},
	pbs: {
		management: "Verwaltung",
		register: "PBS erstellen",
		title: "Tuxis PBS",
	},
	products: {
		product_groups: "Produktgruppen",
		products: "Produkte",
		title: "Produkte",
	},
	shared: {
		relations: "Beziehungen",
	},
	vps: {
		create: "VPS erstellen",
		management: "Verwaltung",
		private_network: "Private Netzwerke",
		title: "Virtuelle private Server",
	},
};

export default side_nav;
